<template>
  <div v-if="false"/>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import dayjs from 'dayjs'

export default {
  name: 'NotificationToast',
  data() {
    return {
      count: 0,
      notificationPrompt: 15,
      sessionSearch: null,
      timeZone: 'Europe/Berlin',
      groupName: null,
      customNotificationGroup: null,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      configForKey: 'config/configForKey',
      list: 'personalProgram/list',
      instance: 'instancesState/getInstance',
      locale: 'instancesState/getLanguage',
      eventShort: 'instancesState/getEvent',
    }),
    programReminder() {
      return this.configForKey('app_config').config[0].Notification?.programReminder ? this.configForKey('app_config').config[0].Notification.programReminder : false
    },
    signalRConnection() {
      return this.configForKey('app_config').config[0].Notification?.signalRConnection ? this.configForKey('app_config').config[0].Notification.signalRConnection : false
    },
    signalRReminder() {
      return this.configForKey('app_config').config[0].Notification?.signalRReminder ? this.configForKey('app_config').config[0].Notification.signalRReminder : false
    },
    signalRCustomNotifications() {
      return this.configForKey('app_config').config[0].Notification?.signalRCustomNotifications ? this.configForKey('app_config').config[0].Notification.signalRCustomNotifications : false
    },
    disableNotificationsForApp() {
      return this.configForKey('app_config').config[0].Notification?.disableNotificationsForApp ? this.configForKey('app_config').config[0].Notification.disableNotificationsForApp : false
    },
  },
  created() {
    if (this.signalRConnection) {
      this.$notificationHub.$on('notification-added', this.showToast)
    }
  },
  async mounted() {
    // Can be removed if "initialuzed in App.vue is solving the problem"
    // const waitFor = delay => new Promise(resolve => setTimeout(resolve, delay))
    // await waitFor(500);

    if (this.signalRReminder) this.groupName = this.instance && this.user && this.eventShort ? `${this.instance}_Event_${this.eventShort}_${this.user.UserId}` : null
    if (this.signalRCustomNotifications) this.customNotificationGroup = this.instance && this.eventShort ? `${this.instance}_Event_${this.eventShort}_CustomNotification` : null
    if (this.groupName) this.$notificationHub.startSignalR(this.instance, this.groupName)
    if (this.customNotificationGroup && !(localStorage.getItem('isApp') === 'true' && this.disableNotificationsForApp)) {
      this.$notificationHub.startSignalR(this.instance, this.customNotificationGroup)
      }
    await this.loadConfig()
    const config = this.configForKey('app_config').config[0]

    if (config?.NotificationSettings?.eventTimeZone) {
      this.timeZone = config.NotificationSettings.eventTimeZone
    }

    if (config?.NotificationSettings?.notificationPrompt) {
      this.notificationPrompt = config.NotificationSettings.notificationPrompt
    }

    if (this.programReminder) {
      this.sessionInterval(this.list)
    }
  },
  methods: {
    ...mapActions({
      set: 'personalProgram/set',
      loadConfig: 'config/loadConfig',
    }),
    showToast({ notification }) {
      const notify = JSON.parse(notification)
      // Use a shorter name for this.$createElement
      const h = this.$createElement
      // Increment the toast count
      this.count += 1
      const toastId = `my-toast-${this.count += 1}`
      // Create the message
      const vNodesMsg = h(
        'div',
        { class: ['notification-box__container'] },
        [
          notify.hasOwnProperty('Description') ? notify.Description : '',
        ],
      )
      let link

      switch (notify.Type) {
        case 'CustomNotification':
          link = notify.hasOwnProperty('OptionalLink') ? notify.OptionalLink : ''
          break
        default:
          link = notify.hasOwnProperty('Type') && notify.Type === 'SessionStart' ? `/program/${this.instance}/${this.eventShort}/${this.locale}?session=${notify.SessionId}` : `/myarea/${this.instance}/${this.eventShort}/${this.locale}/evaluation?id=${notify.SessionId}`
          break
      }
      // Create buttons
      const target = notify.hasOwnProperty('Type') && notify.Type === 'SessionStart' ? '_self' : '_blank'
      const btnContainer = h(
        'div',
        { class: 'notification-box__evaluate-options' },
        link ? [
          h(
            'b-button',
            { class: 'btn-primary-notification', on: { click: () => this.openLink(link, target) } },
            notify.hasOwnProperty('Type') && notify.Type === 'SessionStart' ? this.$t('VMX.notificationbox_go-to-link') : this.$t('VMX.notificationbox_start-evaluation'),
          ),
          h(
            'b-button',
            { class: 'btn-outline-primary-notification __notnow', on: { click: () => this.$bvToast.hide(toastId) } },
            this.$t('VMX.notificationbox_not-now'),
          ),
        ] :
        [
          h(
            'b-button',
            { class: 'btn-outline-primary-notification __notnow', on: { click: () => this.$bvToast.hide(toastId) } },
            this.$t('VMX.notificationbox_not-now'),
          ),
        ],
      )

      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          h(
            'strong',
            { class: 'mr-2 toast-title' },
            notify.hasOwnProperty('Name') ? notify.Name : '',
          ),
        ],
      )
      // h('b-icon-gear-fill', { class: 'ml-auto notification-box__settings-btn', on: { click: () => this.$bvToast.hide(toastId) } }),
      // Pass the VNodes as an array for message and title

      const customFlexContainer = h(
        'div',
        { class: 'notification-box__flex-container' },
        [
          h(
            'img',
            { attrs: { src: notify.Image } },
          ),
          h(
            'div',
            { class: 'notification-box__flex-container-description-buttons' },
            [
              h(
                'div',
                { class: 'notification-box__flex--description', domProps: { innerHTML: notify.hasOwnProperty('Description') ? notify.Description : '' } },
              ),
              btnContainer,
            ],
          ),
        ],
      )

      const flexContainer = h(
        'div',
        { class: 'notification-box__flex-container' },
        [
          h(
            'div',
            { class: 'notification-box__flex-container-description-buttons' },
            [
              h(
                'div',
                { class: 'notification-box__flex--description', domProps: { innerHTML: notify.hasOwnProperty('Description') ? notify.Description : '' } },
              ),
              btnContainer,
            ],
          ),
        ],
      )

      let toastArr
      switch (notify.Type) {
        case 'CustomNotification':
          toastArr = notify.hasOwnProperty('Description') ? [customFlexContainer] : [btnContainer]
          break
        default:
          toastArr = notify.hasOwnProperty('Description') ? [flexContainer] : [btnContainer]
          break
      }

      this.$bvToast.toast(toastArr, {
        title: vNodesTitle,
        solid: true,
        variant: 'info',
        id: toastId,
        noCloseButton: false,
        autoHideDelay: 60000,
      })
    },
    openLink(link, target) {
      window.open(link, target)
    },
    sessionInterval(sessions) {
      this.sessionSearch = setInterval(() => {
        this.checkSessionTime(sessions)
      }, 60000)
    },
    checkSessionTime(sessions) {
      if (sessions?.Schedule) {
        // sort date to get earliest sessions
        sessions.Schedule.sort((a, b) => new Date(a.Start) - new Date(b.Start))
        const result = sessions.Schedule.filter((session) => {
          // substract 15 + 1 mins to get a notification between actual prompt
          const sessionStart = dayjs(session.Start)
            .subtract(this.notificationPrompt + 1, 'minutes')
            .toDate()
          // add a min to get a notification when on starting time
          const sessionStartExceeded = dayjs(session.Start)
            .add(1, 'minutes')
            .toDate()

          const notificationReady = dayjs(dayjs().tz(this.timeZone).format().slice(0, 19))
            .isBetween(sessionStart, sessionStartExceeded)
          return notificationReady
        })

        if (result.length > 0) {
          result.forEach((session) => {
            if (!session.hasOwnProperty('Notified')) {
              session.Notified = true
              this.set({ session })
              const notification = JSON.stringify({ ...session })
              this.showToast({ notification })
            }
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
  .notification-box__flex-container {
    display: flex;

    img{
      height: 200px;
      padding: 0 20px 0 0;
    }
  }

    .notification-box__flex--title{
      font-size: 18px;
    }

    .notification-box__flex--description{
      font-size: 16px;
      padding-bottom: 20px;
    }
  .notification-box__flex-container-description-buttons {
    display: flex;
    /* padding: 0 0 20px 0; */
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;



  }
  .b-toaster-slot{
    max-width: 600px !important;
  }

  .toast-header{
    color: black !important;
    background-color: white !important;
    border-bottom: 0 solid rgba(0, 0, 0, 0) !important;
  }

  .toast-body{
    color: black !important;
    background-color: white !important;
    display: flex;
    padding: 0;
  }
  .b-toast{
    margin-bottom: 10px !important;
    max-width: 600px !important;
    :focus { outline: none; }
  }
  .toast{
    padding: 20px;
    color: black !important;
    background-color: white !important;
    border-color: transparent !important;
    max-width: 600px !important;
    flex-basis: 600px !important;
    box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.2);
  }

  .btn-primary-notification:hover {
      background-color: #5a6268 !important;
      color: var(--primary-contrast) !important;
      border-color: var(--primary-contrast) !important;
  }
  .btn-primary-notification {
      background-color: var(--primary) !important;
      color: var(--primary-contrast) !important;
      border-color: var(--primary-contrast) !important;
  }

  .btn-outline-primary-notification {
      background-color: var(--primary-contrast) !important;
      color: var(--primary) !important;
      border-color: var(--primary) !important;
  }
  .btn-outline-primary-notification:hover {
      background-color: #5a6268 !important;
      color: var(--primary-contrast) !important;
      border-color: var(--primary-contrast) !important;
  }

  button.close{
    top: -2px;
    position: relative;
  }

  .notification-box__container{
    background-color: white;
    padding: 0 15px 15px 0;
    font-size: 16px;
  }

  .toast-title{
    /* white-space: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;
  }

  .notification-box__evaluate-options{
    display: flex;
    align-items: center;

  button{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
    .__notnow{
      margin-left: 5px;
    }
  }
   .notification-box__settings-btn{
    color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }


   @media (max-width: 650px) {
    .notification-box__flex-container {
      flex-wrap: wrap;
    }
  }
</style>
